import { icons } from 'src/assets/iconDef/icon.def';

export const houseKeepingMenuDef = [
    {
        name: 'menu.house_keeping',
        icon: 'fa fa-building-o',
        resource: 'house_keeping',
        url: 'house_keeping',
        auto_crud: true,
        check_permission: false
    },
    {
        name: 'menu.bed_dashborad_summary_view',
        resource: 'housekeeping_bed_format',
        icon: 'fa fa-plus-square',
        url: 'housekeeping_bed_format',
        auto_crud: true,
        breadcrumb: 'housekeeping',
        check_permission: false
    },
    {
        name: 'menu.clearance_status',
        icon: 'fa fa-h-square',
        url: 'clearance_status_housekeeping',
        auto_crud: false,
        showMenu: true
    },
    {
        name: 'menu.bed_management',
        icon: 'fa fa-h-square',
        resource: "encounter_ipAdmission",
        url: 'bed-management',
        auto_crud: false,
        showMenu: true,
        check_permission: false
    },
    {
        name: 'menu.housekeeping_clearance',
        resource: 'housekeeping_clearance',
        icon: 'fa fa-plus-square',
        url: 'housekeeping_clearance',
        auto_crud: true,
        breadcrumb: 'housekeeping-clearance',
        showMenu: false
    }
]

